import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'wba-form-loeschen-button-leiste',
    templateUrl: './form-loeschen-button-leiste.component.html',
    standalone: false
})
export class FormLoeschenButtonLeisteComponent{

  @Input() _id = '';
  @Input() btnClass = '';
  @Input() btnLabel = 'Dieses Einkommen löschen';
  @Output('deleteEvent') deleteEvent = new EventEmitter<void>();

}
